<template>
  <div>
    <el-row class="detail-header-wrap">
      <BaseHeader
          title="商品詳細"
          icon="shopping-cart" />
      <BaseBackButton
          :is-show="showBackButton"
          return-destination="/product" />
      <BaseDetailMoveData
          :id="dataTitle"
          :list-index="listIndex"
          :mode="mode"
          :array-lists="productList"
          :path-parameter="['node.uuid']"
          :can-move-data="canMoveData"
          title="品番"
          router-path="/product/" />
      <span class="action_button">
        <el-dropdown
            v-show="showActionButton"
            @command="actionCommand">
          <el-button size="small"
              :disabled="!isActive">
            アクション
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu
              slot="dropdown"
              class="header-action-menu">
            <el-dropdown-item
                v-show="showEditButton"
                :disabled="disableEditButton"
                :command="define.MODE.EDIT">
              編集
            </el-dropdown-item>
            <el-dropdown-item
                v-show="showInvalidateButton"
                :disabled="disableInvalidateButton"
                :command="define.MODE.DELETE">
              削除
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <BaseButton
            v-show="showSaveButton"
            @click="cancel">
          キャンセル
        </BaseButton>
        <BaseButton
            v-show="showSaveButton"
            :disabled="!isChanged"
            @click="save">
          保存
        </BaseButton>
      </span>
    </el-row>

    <el-tabs
        v-model="activeTabName"
        type="border-card"
        class="product-detail">
      <!-- 基本情報 tab -->
      <el-tab-pane name="basicInfo">
        <span slot="label"
            :class="['tab_label', { 'is-changed': basicInfoChanged }]">
          <i class="fas fa-clipboard" /> 基本情報
        </span>
        <ProductBasicInfo
            ref="basicInfo"
            :product="productDetail"
            :origin-data="originData"
            :mode="mode"
            :store-path="storePath"
            @change="(isChanged) => onChange(isChanged, 'basic')" />
      </el-tab-pane>
      <!-- 商品説明 tab -->
      <el-tab-pane name="introduction">
        <span slot="label"
            :class="['tab_label', { 'is-changed': introductionChanged }]">
          <i class="fas fa-clipboard" /> 商品説明
        </span>
        <ProductIntroduction
            :product="productDetail"
            :origin-data="originData"
            :mode="mode"
            :store-path="storePath"
            @change="(isChanged) => onChange(isChanged, 'introduction')" />
      </el-tab-pane>
      <!-- SKU tab -->
      <el-tab-pane v-if="isNormal"
          name="skuInfo">
        <span slot="label"
            :class="['tab_label', { 'is-changed': skuInfoChanged }]">
          <i class="el-icon-goods" /> SKU
        </span>
        <ProductSku
            ref="skuInfo"
            :product="productDetail"
            :origin-data="originData"
            :mode="mode"
            :store-path="storePath"
            @change="(isChanged) => onChange(isChanged, 'sku')" />
      </el-tab-pane>
      <!-- バンドル tab -->
      <el-tab-pane v-if="isBundle || isSet"
          name="bundleInfo">
        <span slot="label"
            :class="['tab_label', { 'is-changed': bundleInfoChanged }]">
          <i class="el-icon-goods" /> {{ isBundle ? 'バンドル' : 'セット' }}
        </span>
        <ProductBundleSet
            ref="bundleInfo"
            :product="productDetail"
            :origin-data="originData"
            :mode="mode"
            :store-path="storePath"
            :is-bundle="isBundle"
            @change="(isChanged) => onChange(isChanged, 'bundle')" />
      </el-tab-pane>
      <!-- 画像 tab -->
      <el-tab-pane
          name="image">
        <span slot="label"
            :class="['tab_label', { 'is-changed': imageInfoChanged }]">
          <i class="fas fa-image" /> 画像
        </span>
        <ProductImages
            ref="imageInfo"
            :product="productDetail"
            :origin-data="originData"
            :mode="mode"
            :store-path="storePath"
            :file-data-list="fileDataList"
            @change="(isChanged) => onChange(isChanged, 'image')" />
      </el-tab-pane>
      <!-- 素材 tab -->
      <!-- <el-tab-pane>
        <span slot="label"
            :class="['tab_label', { 'is-changed': materialInfoChanged }]">
          <i class="el-icon-goods" /> 素材
        </span>
        <ProductMaterials
            @change="(isChanged) => onChange(isChanged, 'material')" />
      </el-tab-pane> -->
    </el-tabs>
    <!-- 各html項目のプレビューダイアログ -->
    <HtmlPreviewDialog
        :store-path="storePath" />
  </div>
</template>

<style scoped>
span.tab_label.is-changed::after {
  color: deeppink;
  font-size: x-small;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  font-family: "Font Awesome 5 Free";
  font-weight: 900; content: "\f069";
}

.product-detail .el-collapse-item table:not(.product-detail-items) th,
.product-detail .el-collapse-item table:not(.product-detail-items) td,
.product-detail .el-form .el-form-item__label,
.product-detail .el-form .el-form-item__content {
    padding: 6px 15px;
    font-size: 14px;
    text-align: left;
    vertical-align: top;
    line-height: 30px;
}

.product-detail .table .el-input__inner,
.product-detail .table .el-input-number,
.product-detail .table .el-select,
.product-detail .table-vertical .el-input__inner,
.product-detail .table-vertical .el-select,
.product-detail .el-collapse .el-input__inner,
.product-detail .el-collapse .el-select {
    height: 32px!important;
    line-height: 28px;
    vertical-align: top;
}

.product-detail .el-collapse-item table .el-tag {
    margin: 2px 2px 2px 4px;
}

.product-detail >>> .el-tabs__content {
  /* 固定させたいため自動で付加されるoverflowを指定 */
  overflow: visible;
}

</style>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import store from '@/store/index'
import _ from 'lodash'
import common from '@/utils/common'
import message from '@/utils/message'
import compare from '@/utils/compareUtils'

import * as define from '@/define'
import * as config from '@/config'
import * as query from '@/queries/product'

import ProductBasicInfo from '@/components/pages/product/ProductBasicInfo'
import ProductIntroduction from '@/components/pages/product/ProductIntroduction'
// import ProductMaterials from '@/components/pages/product/ProductMaterials'
import ProductSku from '@/components/pages/product/ProductSku'
import ProductBundleSet from '@/components/pages/product/ProductBundleSet'
import ProductImages from '@/components/pages/product/ProductImages'

import BaseButton from '@/components/atoms/BaseButton'
import BaseDetailMoveData from '@/components/molecules/BaseDetailMoveData'
import BaseHeader from '@/components/molecules/BaseHeader'
import BaseBackButton from '@/components/molecules/BaseBackButton'
import HtmlPreviewDialog from '@/components/organisms/HtmlPreviewDialog'

import x from '@/components/mixins/mixin'
import confirmDiscardOnLeave from '@/components/mixins/confirmDiscardOnLeave'
import detailUtil from '@/components/mixins/detailUtil'

const returnDestination = '/Product'
const returnDestinationTitle = 'CCS - 商品一覧'

export default {
  name: 'ProductDetail',
  components: {
    ProductBasicInfo,
    ProductIntroduction,
    // ProductMaterials,
    ProductSku,
    ProductBundleSet,
    ProductImages,
    BaseButton,
    BaseHeader,
    BaseBackButton,
    BaseDetailMoveData,
    HtmlPreviewDialog
  },
  mixins: [ x, confirmDiscardOnLeave, detailUtil ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      activeTabName: 'basicInfo',
      changedTabs: [],
      originData: {},
      isChanged: false,
      canMoveData: false,
      reservedTransition: false,
      fileDataList: []
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      listIndex: (state) => state.Product.listIndex,
      size: (state) => state.Product.size,
      mode: (state) => state.Product.mode,
      returnList: (state) => state.Product.returnList,
      colorGroupMaster: state => state.Product.colorGroupMaster,
      sizeGroupMaster: state => state.Product.sizeGroupMaster
    }),
    ...mapGetters({
      productDefaultValue: 'productDefaultValue',
      allowDuplicateComponent: 'allowDuplicateComponent'
    }),
    ...mapGetters('ProductDetail', {
      productDetail: 'productDetail',
      productDatetime: 'productDatetime'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    storePath () {
      return 'Product'
    },
    pageTitle () {
      return this.mode === define.MODE.NEW
        ? '商品登録'
        : '商品詳細'
    },
    dataTitle () {
      return this.productDetail.code
        // 読み込み完了時「品番コード」。無効データの場合「無効データ - 品番コード」
        ? (this.isActive ? '' : '無効データ - ') + (this.originData.code || '')
        // 読み込み未完了時
        : ''
    },
    basicInfoChanged () {
      return this.changedTabs.includes('basic')
    },
    introductionChanged () {
      return this.changedTabs.includes('basic')
    },
    skuInfoChanged () {
      return this.changedTabs.includes('sku')
    },
    bundleInfoChanged () {
      return this.changedTabs.includes('bundle')
    },
    imageInfoChanged () {
      return this.changedTabs.includes('image')
    },
    materialInfoChanged () {
      return this.changedTabs.includes('material')
    },
    showBackButton () {
      return this.mode === define.MODE.NORMAL && !this.$isFunctionDisabled(define.PermissionKeys.Product.LIST)
    },
    showActionButton () {
      return [define.MODE.NORMAL].includes(this.mode)
    },
    isActive () {
      return (this.productDetail.isActive === 1)
    },
    showSaveButton () {
      return !this.showActionButton
    },
    showEditButton () {
      return this.$isFunctionShown(define.PermissionKeys.Product.Detail.EDIT)
    },
    disableEditButton () {
      return this.$isFunctionDisabled(define.PermissionKeys.Product.Detail.EDIT)
    },
    showInvalidateButton () {
      return this.$isFunctionShown(define.PermissionKeys.Product.Detail.INVALIDATE)
    },
    disableInvalidateButton () {
      return this.$isFunctionDisabled(define.PermissionKeys.Product.Detail.INVALIDATE)
    },
    isNormal () {
      return this.productDetail.productCategory === define.PRODUCT_CATEGORY.NORMAL
    },
    isBundle () {
      return this.productDetail.productCategory === define.PRODUCT_CATEGORY.BUNDLE
    },
    isSet () {
      return this.productDetail.productCategory === define.PRODUCT_CATEGORY.SET
    },
    sortedList () {
      return this.$store.getters['sortedList'](this.storePath, this.sortCondition('productList'))
    },
    productList () {
      if (this.returnList) {
        return []
      } else {
        return this.sortedList
      }
    }
  },
  watch: {
    productDetail: {
      handler: function (val, oldVal) {
        this.isChanged = this.$_ConfirmDiscardOnLeave_isChanged()
      },
      deep: true
    },
    mode (val) {
      // 既に遷移予定である場合、制御不要
      if (!this.reservedTransition) {
        const route = this.$route
        if (val === define.MODE.NORMAL &&
          (route.params && route.params.id === '0')) {
          this.$router.push({ path: returnDestination })
        }
        // ページタイトルの再設定
        document.title = `CCS - ${this.pageTitle}`
      }
    }
  },
  async created () {
    window.addEventListener('beforeunload', this.onBeforeUnload)
    this.$loadingService.show()

    // 初期化処理
    this.$store.dispatch({
      type: 'set',
      states: {
        [`${this.storePath}/htmlPreviewDialogVisible`]: false,
        [`${this.storePath}/htmlPreviewDialogContent`]: ''
      }
    })
    try {
      const uuid = this.$route.params.id
      await Promise.all([
        // 商品カスタマイズ属性を取得する。
        this.getCustomizeMaster(),
        // カラーグループを取得する。
        this.getColorGroupMaster(),
        // サイズグループを取得する。
        this.getSizeGroupMaster(),
        // ブランドを取得する。
        this.getBrandGroupMaster(),
        // 性別を取得する。
        this.getGenderGroupMaster(),
        // 商品データの取得
        this.getDetailData({ uuid })
      ])

      this.initByMode()

      this.createCompleted = true
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  destroyed () {
    this.setProductDetail(null)
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  },
  beforeRouteEnter (to, from, next) {
    // [beforeRouteEnter]ではvueコンポーネントの生成が未完であるため、「this.$store」で呼び出しができない。
    // そのため、storeのあるファイルをImportし、直接参照している。
    if (to.params && to.params.id === '0' && store.state.Product.mode !== define.MODE.NEW) {
      // 履歴の操作により、入ってきたとき、storeが正しくないので編集
      store.dispatch({ type: 'set', states: { 'Product/mode': define.MODE.NEW } })
    } else if (to.params && to.params.id !== '0' && store.state.Product.mode !== define.MODE.NORMAL) {
      next(vm => {
        vm.updateMode(define.MODE.NORMAL)
      })
      return
    }
    next()
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      // 新規作成完了後
      if (from.params && from.params.id === '0') {
        // 新規登録完了時、戻る等でいきなり新規作成とならないように履歴を修正
        document.title = returnDestinationTitle
        history.replaceState(null, null, returnDestination)
      }

      // 詳細間移動時の処理.
      // modeの初期化とデータの初期化を行う.
      this.$loadingService.show()
      this.$_ConfirmDiscardOnLeave_watchEnd()
      this.updateMode(define.MODE.NORMAL)
      const uuid = to.params.id

      await this.getDetailData({ uuid })
      next()
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  beforeRouteLeave (to, from, next) {
    // 別ページへ移動する場合、modeを初期化する.
    try {
      this.reservedTransition = true
      this.updateMode(define.MODE.NORMAL)

      next()
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    }
  },
  methods: {
    ...mapActions('ProductDetail', [
      'fetchProductDetail',
      'fetchProductDatetime',
      'setProductDetail'
    ]),
    ...mapMutations('Product', {
      updateListItem: 'update'
    }),
    /**
     * 商品詳細情報を取得します。
     * @param {Boolean} [updateList=false] 一覧の情報を更新する場合、true.
     * @param {String} uuid 未設定の場合、現在のrouteから取得する.
     */
    async getDetailData ({ updateList = false, uuid } = {}) {
      try {
        this.$loadingService.show()
        if (this.mode !== define.MODE.NEW) {
          if (!uuid) {
            uuid = this.$route.params.id
          }

          // listIndexの更新
          this.$_detailUtil_onGetDetailData((element) => element.node.uuid === uuid)

          await this.fetchProductDatetime({ uuid })
          await this.fetchProductDetail({ uuid, productDatetime: this.productDatetime })
        } else {
          const productDetailObj = {
            uuid: null,
            code: '',
            isActive: 1,
            name: '',
            nameKana: '',
            brand: { name: '', code: '' },
            productType: null,
            productCategory: null,
            subBrand: { name: '', code: '' },
            makerProductCode: '',
            productYear: '',
            seasonCode: '',
            category: [],
            gender: [],
            salesPeriodFrom: null,
            salesPeriodTo: null,
            isOnline: 0,
            onlineDatetime: null,
            offlineDatetime: null,
            colorGroupCode: null,
            mainColorCode: null,
            sizeGroupCode: null,
            productDescription: '',
            productDetail: '',
            catchphrase: '',
            mediaCoverage: '',
            seoMeasurement: '',
            appeal: '',
            remarks: '',
            tags: [],
            isBuyableOnly: 1,
            isShipment:
              this.productDefaultValue.product_is_inventory_control != null
                ? Number(this.productDefaultValue.product_is_inventory_control) : 1,
            isInventoryControl: 1,
            isSearchable: 1,
            isSearchableIfUnavailable:
              this.productDefaultValue.product_is_searchable_if_unavailable != null
                ? Number(this.productDefaultValue.product_is_searchable_if_unavailable) : 1,
            images: [],
            fkus: [],
            attributes: [],
            colorVariations: [],
            sizeVariations: []
          }
          this.setProductDetail(productDetailObj)
        }
        this.originData = await _.cloneDeep(this.productDetail)
        this.productIndex = -1

        // ファイル情報の解放
        this.fileDataList = []

        if (updateList) {
          this.updateListItem(this.productDetail)
        }
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      switch (mode) {
        case this.define.MODE.EDIT:
          this.changeMode(this.define.MODE.EDIT)
          break
        case define.MODE.DELETE:
          this.delete()
          break
        default: {}
      }
    },
    /**
     * 保存処理を実行します。
     */
    save () {
      this.$validator.validate().then(result => {
        if (result) {
          if (this.showValidateErrorDialogIfNeed()) {
            return
          }

          this.$confirm(`保存しますか？`, define.MESSAGE_TITLE, {
            confirmButtonText: 'はい',
            cancelButtonText: 'いいえ',
            type: 'warning'
          }).then(async () => {
            try {
              this.$loadingService.show()

              // 未アップロードの画像はアップロードする
              const preUploadImages = [].concat(
                this.productDetail.images.filter((image) => image.isNew === true && image.hash == null),
                this.productDetail.fkus.flatMap((fku) => fku.images.filter((image) => image.isNew === true && image.hash == null))
              )
              if (preUploadImages.length > 0) {
                await Promise.all(preUploadImages.map(async (image) => {
                  // 1. ハッシュファイル名を作る
                  const imageFileData = this.fileDataList.find((img) => img.id === image.id)
                  const hash = common.getUniqueKey()
                  const tempArray = imageFileData.file.name.split('.')
                  const fileKey = hash + '.' + _.last(tempArray)
                  // 2. 画像アップロード先の署名付きURL取得
                  const res = await common.apiAxios(config.GET_S3_SIGNED_URL,
                    { method: 'GET', params: { urlType: 2, key1: 'm_product', key2: 'image_src', key3: 'upload_folder_key', fileKey } })
                  const signedUrl = res.data.signedUrl
                  // 3. 商品画像をアップロードする
                  const request = new XMLHttpRequest()
                  request.open('PUT', signedUrl, false)
                  request.send(imageFileData.file)
                  if (request.status !== 200) {
                    throw new Error('アップロードリクエストに失敗しました。')
                  }
                  image.hash = fileKey
                })).catch((error) => {
                  throw error
                })
              }

              // 商品情報更新APIを呼ぶ
              const requestProduct = this.buildProductRequest()
              const res = await this.callProductUpdate({ method: this.mode === define.MODE.NEW ? 'post' : 'put', uuid: this.productDetail.uuid, data: requestProduct })

              // 変更箇所ありフラグを落とす
              this.isChanged = false
              await this.$_ConfirmDiscardOnLeave_watchEnd()
              // 再描画用のルーティングを行う
              if (this.mode === define.MODE.NEW) {
                // モードを参照に切り替える
                this.updateMode(define.MODE.NORMAL)
                this.reservedTransition = true
                this.$router.push({ path: `/product/${res.data.uuid}` })
              } else {
                // モードを参照に切り替える
                this.updateMode(define.MODE.NORMAL)
                await this.getDetailData({ updateList: true })
              }

              this.$notify.success('保存しました。')
            } catch (error) {
              const data = _.get(error, 'response.data')
              if (data == null) {
                common.addError(error, { msg: message.MSG_502() })
              } else {
                if (common.hasLastUpdatedError(error)) {
                  common.addError(error, { msg: message.MSG_534() })
                } else if (this.hasDuplicateProductError(error)) {
                  common.addError(error, { msg: message.MSG_537() })
                } else if (this.hasDuplicateSKUError(error)) {
                  common.addError(error, { msg: message.MSG_538() })
                } else if (this.hasUsinComponentSKUError(error)) {
                  common.addError(error, { msg: message.MSG_543() })
                } else if (this.hasOrderdSKUError(error)) {
                  common.addError(error, { msg: message.MSG_544() })
                } else {
                  if (this.mode === define.MODE.NEW) {
                    common.addError(error, { msg: message.MSG_535() })
                  } else {
                    common.addError(error, { msg: message.MSG_536() })
                  }
                }
              }
              this.$notify.error({ error: error })
              throw error
            } finally {
              this.$loadingService.close()
            }
          }).catch((reason) => {
            if (reason === 'cancel') {
              this.$notify.info('キャンセルしました。')
            } else {
              throw reason
            }
          })
        } else {
          // エラー箇所のタブを開く
          let tab = this.activeTabName
          let targetErrorTab = null
          Array.from(document.querySelectorAll('.el-tab-pane')).some(element => {
            if (element.querySelector('.is-error')) {
              tab = element.id.replace('pane-', '')
              targetErrorTab = element
              return true
            }
            return false
          })
          this.activeTabName = tab

          // エラー箇所のパネルを開く
          const targetTab = _.get(this.$refs, `${tab}.activeCollapseName`, [])
          const panel = new Set(targetTab)
          document.querySelectorAll('.el-collapse-item').forEach(element => {
            if (element.querySelector('.is-error')) {
              panel.add(element.id)
            }
          })

          _.set(this.$refs, `${tab}.activeCollapseName`, Array.from(panel))

          // SKUタブ時対象のSKUを開く
          if (this.activeTabName === 'skuInfo') {
            let tabName = ''
            Array.from(targetErrorTab.querySelectorAll('.el-tab-pane')).some(element => {
              if (element.querySelector('.is-error')) {
                tabName = element.id.replace('pane-', '')
                return true
              }
              return false
            })

            _.set(this.$refs, `${tab}.activeTabName`, tabName)
          }

          // エラー発生個所へ移動
          setTimeout(function () {
            let error = document.querySelector('.is-error')
            if (error) {
              error.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
            }
          }, 200)
        }
      })
    },
    /**
     * 商品情報更新 API
     * @param {String} method
     * @param {String} uuid
     * @param {Object} data request body
     */
    async callProductUpdate ({ method, uuid, data } = {}) {
      const heads = { 'X-CCS-Last-Updated-At': this.productDatetime }
      let url = ''
      switch (method.toLowerCase()) {
        case 'post':
          url = `${config.PRODUCT_URL}`
          break
        case 'put':
        case 'delete':
          url = `${config.PRODUCT_URL}/${uuid}`
          break
      }
      const response = await common.apiAxios(url, { method: method, data: data, heads })
      return response
    },
    /**
     * 商品情報更新 API コール用にリクエストを生成します。
     * @return {Object} リクエストボディ
     */
    buildProductRequest () {
      if (this.MODE === define.MODE.NEW) {
        // 新規登録時はそのまま送る
        return this.productDetail
      } else {
        // 編集時は差分のみ送る
        const requestBody = _.chain(compare.diff(this.originData, this.productDetail, true))
          .pick([
            'code', 'name', 'nameKana', 'productNameAbbreviation', 'coreProductName', 'brand', 'productType', 'productCategory',
            'subBrand', 'makerProductCode', 'productYear', 'seasonCode', 'mainCategoryCode',
            'category', 'gender', 'salesPeriodFrom', 'salesPeriodTo', 'isOnline', 'onlineDatetime',
            'offlineDatetime', 'colorGroupCode', 'mainColorCode', 'sizeGroupCode',
            'productDescription', 'productDetail', 'catchphrase', 'mediaCoverage',
            'seoMeasurement', 'appeal', 'remarks', 'tags', 'isBuyableOnly',
            'isShipment', 'isInventoryControl', 'isSearchable', 'isSearchableIfUnavailable',
            'attributes'
          ])
          .cloneDeep()
          .value()
        // 品番コードは差分がなくてもリクエストに送る
        requestBody.code = this.productDetail.code

        this.buildAttributes(requestBody, this.productDetail)

        const images = this.build(this.productDetail.images, this.originData.images, [])
        if (images.length > 0) requestBody.images = images

        const fkus = this.build(this.productDetail.fkus, this.originData.fkus,
          [
            { name: 'images' }, { name: 'skus', children: [{ name: 'components' }] }
          ])
        if (fkus.length > 0) requestBody.fkus = fkus
        return requestBody
      }
    },
    build (current, origin, children = []) {
      return _.chain(compare.diff(origin, current, true))
        .cloneDeep()
        .map((val, key) => {
          // fku,skuに変更がある場合、キーとなるcolor,sizeの情報は変更なくてもリクエストに追加する
          const color = _.get(current, `${key}.color`, null)
          const size = _.get(current, `${key}.size`, null)
          const uuid = _.get(current, `${key}.uuid`, null)
          const id = _.get(current, `${key}.id`, null)
          const code = _.get(current, `${key}.code`, null)
          if (color) val.color = color
          if (size) val.size = size
          if (uuid) val.uuid = uuid
          if (id) val.id = id
          if (code) val.code = code
          const isNew = _.get(current, `${key}.isNew`, null)
          const hash = _.get(current, `${key}.hash`, null)
          const file = _.get(current, `${key}.file`, null)
          // 商品画像でfile情報を持っている場合、アップロード済みであるためファイル情報は切り落とす
          if (isNew != null && hash != null && file != null) {
            delete val.file
          }
          for (let i = 0; i < children.length; i++) {
            const child = children[i]
            const childValue = this.build(
              _.get(current, `${key}.${child.name}`, {}),
              _.get(origin, `${key}.${child.name}`, {}),
              child.children
            )
            if (_.size(childValue) > 0) {
              _.set(val, child.name, childValue)
            }
          }
          this.buildAttributes(val, _.get(current, key))
          return val
        })
        .value()
    },
    buildAttributes (request, value) {
      if (_.has(request, 'attributes')) {
        request.attributes = _.chain(request.attributes)
          .entries()
          .map(([key, val]) => {
            if (!val) return null
            const attrId = _.get(value, `attributes.${key}.attrId`, '')
            return attrId === '' ? null : { attrId: attrId, attrValue: val.attrValue }
          })
          .filter(val => val != null)
          .value()
      }
    },
    /**
     * 編集内容をチェックして、エラーがある場合ダイアログを表示する
     * @returns {Boolean} ダイアログを表示した場合、true
     */
    showValidateErrorDialogIfNeed () {
      const message =
        this.getDupulicateComponentErrorMessage() ||
        ''
      if (message !== '') {
        this.$alert(
          message, define.MESSAGE_TITLE,
          { type: 'warning', showClose: false }
        )
        return true
      }
      return false
    },
    /**
     * 構成品重複メッセージを取得する
     * @returns {String} エラーメッセージ
     */
    getDupulicateComponentErrorMessage () {
      if (this.allowDuplicateComponent === '1') {
        return null
      }

      if (this.isBundle || this.isSet) {
        const bundleData = _.get(this.productDetail, 'fkus.0.skus.0.components', [])
        if (bundleData.some((val, index) => {
          const skuCode = _.get(val, 'sku.code', _.get(val, 'product.code', ''))
          return bundleData.some((otherVal, otherIndex) => {
            const otherSkuCode = _.get(otherVal, 'sku.code', _.get(otherVal, 'product.code', ''))
            return (otherIndex !== index &&
                otherSkuCode === skuCode)
          })
        })) {
          const message = '構成品に同一商品は選択できません。'
          this.activeTabName = 'bundleInfo'
          return message
        }
      }
      return null
    },
    /**
     * 編集キャンセル
     */
    cancel: function () {
      const cancelEdit = () => {
        this.updateMode(define.MODE.NORMAL)
        this.$_ConfirmDiscardOnLeave_watchEnd()
        this.isChanged = false
      }
      if (!this.isChanged) {
        cancelEdit()
        return
      }
      this.$confirm(
        this.mode === define.ACCOUNT_MODE.NEW
          ? '商品登録を中止しますか？'
          : '変更を破棄しますか？',
        define.MESSAGE_TITLE, {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        }).then(() => {
        this.setProductDetail(_.cloneDeep(this.originData))
        cancelEdit()
      })
    },
    /**
     * モードに対応する初期処理を実行します。
     */
    initByMode () {
      this.originData = _.cloneDeep(this.productDetail)
      this.$_ConfirmDiscardOnLeave_watchStart(this.productDetail)
    },
    /**
     * モードの切替を行います。
     */
    changeMode (mode) {
      this.updateMode(mode)
      this.initByMode()
    },
    updateMode (mode) {
      this.$store.commit({
        type: 'set',
        states: {
          'Product/mode': mode
        }
      })
    },
    onBeforeUnload (event) {
      if (this.isChanged) {
        // 変更有の場合、再読み込み確認ダイアログを表示する.
        event.returnValue = 'changed'
      }
    },
    onChange (isChanged, tabName) {
      const index = _.findIndex(this.changedTabs, (val) => val === tabName)
      if (isChanged && index === -1) {
        this.changedTabs.push(tabName)
      } else if (!isChanged && index !== -1) {
        this.changedTabs.splice(index, 1)
      }
    },

    // マスタ取得処理
    async getCustomizeMaster () {
      let res = await common.postGraphQl(query.GRAPH_QL_QUERY_CUSTOMIZE_MASTER, { isMessageControl: true })
      this.$store.dispatch({
        type: 'set',
        states: { [`${this.storePath}/customizeMaster`]: res.data.data.customizeProperties }
      })
    },
    async getColorGroupMaster () {
      let res = await common.postGraphQl(query.GRAPH_QL_QUERY_COLOR_GROUP_MASTER, { isMessageControl: true })
      this.$store.dispatch({
        type: 'set',
        states: { [`${this.storePath}/colorGroupMaster`]: res.data.data.colorGroups }
      })
    },
    async getSizeGroupMaster () {
      let res = await common.postGraphQl(query.GRAPH_QL_QUERY_SIZE_GROUP_MASTER, { isMessageControl: true })
      this.$store.dispatch({
        type: 'set',
        states: { [`${this.storePath}/sizeGroupMaster`]: res.data.data.sizeGroups }
      })
    },
    async getBrandGroupMaster () {
      let res = await common.postGraphQl(query.GRAPH_QL_QUERY_BRAND_MASTER, { isMessageControl: true })
      this.$store.dispatch({
        type: 'set',
        states: { [`${this.storePath}/brandMaster`]: res.data.data.brands }
      })
    },
    async getGenderGroupMaster () {
      let res = await common.postGraphQl(query.GRAPH_QL_QUERY_GENDER_MASTER, { isMessageControl: true })
      this.$store.dispatch({
        type: 'set',
        states: { [`${this.storePath}/genderMaster`]: res.data.data.genders }
      })
    },
    hasDuplicateProductError (error) {
      const code = _.get(error, 'response.data.code')
      if (code !== 400) {
        return false
      }

      return _.chain(error)
        .get('response.data.errors')
        .find(val => val.location === 'duplicateProductCode' && val.reason === 'invalid')
        .value() != null
    },
    hasDuplicateSKUError (error) {
      const code = _.get(error, 'response.data.code')
      if (code !== 400) {
        return false
      }

      return _.chain(error)
        .get('response.data.errors')
        .find(val => val.location === 'duplicateSKUCode' && val.reason === 'invalid')
        .value() != null
    },
    hasUsinComponentSKUError (error) {
      const code = _.get(error, 'response.data.code')
      if (code !== 400) {
        return false
      }

      return _.chain(error)
        .get('response.data.errors')
        .find(val => val.location === 'usingComponent' && val.reason === 'invalid')
        .value() != null
    },
    hasOrderdSKUError (error) {
      const code = _.get(error, 'response.data.code')
      if (code !== 400) {
        return false
      }

      return _.chain(error)
        .get('response.data.errors')
        .find(val => val.location === 'skuOrdered' && val.reason === 'invalid')
        .value() != null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/product/ProductDetailTop.vue